export default function IBeranda({
  width = 16,
  height = 16,
  color = '#252526',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      {...props}
    >
      <path
        d="M2.5 6.91072V13.4999H13.5V6.91072L8 2.63338L2.5 6.91072ZM14.5 13.6666C14.5 14.1268 14.1269 14.4999 13.6667 14.4999H2.33333C1.8731 14.4999 1.5 14.1268 1.5 13.6666V6.82934C1.50008 6.5723 1.61873 6.32962 1.82161 6.17179L7.48828 1.76424L7.54622 1.72322C7.82185 1.54408 8.17815 1.54408 8.45378 1.72322L8.51172 1.76424L14.1784 6.17179C14.3813 6.32962 14.4999 6.5723 14.5 6.82934V13.6666Z"
        fill={color}
      />
      <path
        d="M7.79557 2.15917C7.91593 2.06558 8.08407 2.06558 8.20443 2.15917L13.8711 6.56607C13.9523 6.62922 14 6.72688 14 6.82974V13.6663C14 13.8504 13.8508 13.9997 13.6667 13.9997H10V9.35708C10 9.15984 9.85076 8.99966 9.66667 8.99966H6.33333C6.14924 8.99966 6 9.15984 6 9.35708V13.9997H2.33333C2.14924 13.9997 2 13.8504 2 13.6663V6.82974C2 6.72688 2.04771 6.62922 2.12891 6.56607L7.79557 2.15917Z"
        fill={color}
      />
    </svg>
  );
}
